import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import VehicleTypeIcon from '@/components/VehicleTypeIcon.vue'
import {
  currencyFilter,
  expirationDelta,
  pluralize,
} from '@/utils/string'
import { isExpiredV2 } from '@/utils/quote'
import SkeletonBox from '@/components/SkeletonBox.vue'
import QuoteSummary from '@/models/dto/quoteSummary/QuoteSummary'

interface Props {
  row?: QuoteSummary
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteSummaryMobileCard',
  props: {
    row: { default: null }
  },
  setup(__props: any) {

const props = __props as { row: QuoteSummary };





const isExpired = computed(() => {
  if (!props.row.expirationDatetime) {
    return false
  }
  return isExpiredV2(props.row.expirationDatetime)
})

const routeName = computed(() => {
  const { pickupLocation, dropoffLocation } = props.row
  if (!pickupLocation || !dropoffLocation) {
    return ''
  }

  return `${pickupLocation} > ${dropoffLocation}`
})

const price = computed(() => {
  const isQuoteExpired = isExpiredV2(props.row.expirationDatetime)
  if (isQuoteExpired) {
    return 'Expired'
  }

  const hasSpecialScenario = props.row.promptCall || props.row.salesWillCall || props.row.promptBASCall
  if (hasSpecialScenario) {
    return 'More Info'
  }

  if (!props.row.price) {
    return 'View Prices'
  }

  return currencyFilter(props.row.price)
})

const expiration = computed(() => {
  const timestamp = props.row.expirationDatetime
  if (!timestamp) {
    return 'Invalid Date'
  }
  if (isExpired.value) {
    return 'Expired'
  }

  return expirationDelta(timestamp)
})

const vehiclesDisplayText = computed(() => {
  return props.row.vehicles.map(({ quantity, label }) => `${quantity} ${pluralize(quantity, label)}`)
})

const displayVehicleType = computed(() => {
  if (isExpired.value) {
    return 'Charter Bus'
  }
  return props.row.vehicles[0]?.label || null
})

return { __sfc: true,props, isExpired, routeName, price, expiration, vehiclesDisplayText, displayVehicleType, VehicleTypeIcon, SkeletonBox }
}

})